import { Box, Skeleton } from '@mui/material';

export const WishlistItemPlaceholder = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1.5,
        alignItems: 'center',
      }}
    >
      <Skeleton variant='rounded' width={100} height={80} />
      <Skeleton variant='rectangular' height={40} sx={{ flexGrow: 1 }} />
      <Skeleton variant='rectangular' width={60} height={40} />
    </Box>
  );
};
